export function createUrl(urlPath: string, queryObj: any) {
  const query = new URLSearchParams();

  if (queryObj) {
    Object.entries(queryObj).forEach(([key, value]) => {
      if (value) query.set(key, value as string);
    });
  }

  const queryString = query.toString();
  return `${urlPath}${queryString ? '?' : ''}${query}`;
}
